import { render } from "./ShirtQuantity.vue?vue&type=template&id=6351e0c1"
import script from "./ShirtQuantity.vue?vue&type=script&lang=js"
export * from "./ShirtQuantity.vue?vue&type=script&lang=js"
script.render = render

export default script